module.exports = __webpack_public_path__ + "static/media/no-icon.170b434c.svg";